// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1Xyvd","inputDescription":"styles_inputDescription__2g1WL"};